
import makerjs from "makerjs";
function C08(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  // console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    R = Param[0].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       r = R * 1 * myZoom,       
    //    h = H * 1 * myZoom,
     h=r,w=2*r,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x0=0,y0=0,x1=r,y1=r,x2=2*r,y2=0,glassH = h, glassW = w;

   if (r !== 0) {
       var TxtR = "R="+R;
   }
   var drawAbnormalShapeC08 = {
       paths: {
        "ArcLine": new makerjs.paths.Arc([x0,y0], [x1,y1],[x2,y2]),
        "BottomLine": new makerjs.paths.Line([x0,y0], [x2,y2]),
       }
   };
//    var drawAbnormalShapeC08MarkW = {
//        paths: {
//         "Line": new makerjs.paths.Line([x0,y0-markShift], [x2,y2-markShift]),
//         "LeftLine": new makerjs.paths.Line([x0,y0-2*markShift], [x0,y0]),
//         "RithgLine": new makerjs.paths.Line([x2,y2-2*markShift], [x2,y2]),
//        }
//    };
   var drawAbnormalShapeC08MarkR = {
       paths: {
        "Line": new makerjs.paths.Line([w/2, 0], [w/2, h]),
        // "LineUp": new makerjs.paths.Line([0-markShift, h], [0+markShift, h]),
        // "LineDn": new makerjs.paths.Line([0-markShift, 0], [0+markShift, 0]),
       }
   };
//    makerjs.model.addCaption(drawAbnormalShapeC08MarkR, TxtR, [x0,y0-2*markShift], [x2,y2-2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeC08MarkR, TxtR, [w/2-markShift, 0], [w/2-markShift, h]);//长度文字  
   
  plate={
    models: {
      drawAbnormalShapeC08: drawAbnormalShapeC08,
      }
    };
    markers={
      models: {
        drawAbnormalShapeC08: drawAbnormalShapeC08,
        drawAbnormalShapeC08MarkR: drawAbnormalShapeC08MarkR,
        // drawAbnormalShapeC08MarkH: drawAbnormalShapeC08MarkH,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default C08;